import classNames from 'classnames';
import styled from 'styled-components';
import useIsServerStylesAppended from '../custom-hooks/useIsServerStylesAppended';

const StyledDiv = styled.div`
  &:not(.accordion-item) {
    display: contents;
  }
`;

const ServerStylesConditionalWrapper = ({ children, className = '' }) => {
  const isServerStylesAppended = useIsServerStylesAppended();

  return (
    <StyledDiv className={classNames(className, { 'sr-only': !isServerStylesAppended })}>
      {children}
    </StyledDiv>
  );
};

/**
 * Component to wrap any non-widget components.
 */
export default ServerStylesConditionalWrapper;

/**
 * Higher-order component to wrap any non-widget components.
 */
export const withServerStyles =
  (Component) =>
  ({ className = '', ...passThroughProps }) =>
    (
      <ServerStylesConditionalWrapper className={className}>
        <Component {...passThroughProps} />
      </ServerStylesConditionalWrapper>
    );
